import React, { useContext, useEffect } from "react";
import { Alert, Button, Modal } from "react-bootstrap";

import { Dropdown, DropdownItemProps } from "semantic-ui-react";
import { ICancelTableModal } from "./ICancelTableModal";
import ApplicationContext from "../../../../context/ApplicationContext";
import { cancelTable, tableReminder } from "../../../../services/Service";

export const CancelTableModal: React.FC<ICancelTableModal> = (
  props: ICancelTableModal
): JSX.Element => {
  const context = useContext(ApplicationContext);

  const [payValue, setPayValue] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [hour, setHour] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);

  useEffect(() => {
    setError(false);
    setHour(0);
    setMinutes(0);
  }, [props.show]);

  const hourOptions: DropdownItemProps[] = [];
  const minOptions: DropdownItemProps[] = [];

  for (let i = 0; i < 12; i++) {
    hourOptions.push({ key: i, text: i, value: i });
  }

  for (let i = 0; i < 60; i++) {
    minOptions.push({ key: i, text: i, value: i });
  }

  const onHourChange = (event: any, result: any) => {
    const { name, value } = result || event.target;
    setHour(parseInt(value));
  };

  const onMinutesChange = (event: any, result: any) => {
    const { name, value } = result || event.target;
    setMinutes(parseInt(value));
  };

  const paymentScreen = () => (
    <>
      <div>
        {error ? (
          <Alert key="danger" variant="danger">
            Cannot cancel table due to communication (internet). Please try
            again a few min. If the error persist please contact support
          </Alert>
        ) : (
          <></>
        )}
      </div>

      <div
        style={{
          //width: "100%",
          //justifyContent: "center",
          fontSize: 24,
          //</>display: "flex",
        }}
      >
        Are you sure you want to cancel?
      </div>
    </>
  );

  const customerModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => props.close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Cancel {props.table.description}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{paymentScreen()}</Modal.Body>
          <Modal.Footer className="modal-footer">
            <div>
              <Button
                variant="secondary"
                style={{
                  width: 100,
                  height: 50,
                  fontSize: 20,
                }}
                onClick={() => props.close()}
              >
                Cancel
              </Button>
            </div>
            <Button
              variant="success"
              style={{
                width: 300,
                height: 50,
                fontSize: 20,
              }}
              onClick={() => cancelThisTable()}
            >
              Okay
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  async function cancelThisTable() {
    let totalMins = hour * 60;
    totalMins = totalMins + minutes;

    const isSaved = await cancelTable(
      props.table.uuid,
      context.AuthenticatedUser.getToken()
    );

    if (!isSaved) {
      setError(true);
      return;
    }

    props.close();
  }

  return (
    <>
      <>{customerModal()}</>
    </>
  );
};
